import { Stack, Typography } from '@mui/material'
import { useState } from 'react'

import Item from 'src/components/Changelog/Item'
import PaginationControl from 'src/components/common/DataTable/PaginationControl'
import NoDataAvailable from 'src/components/NoDataAvailable'
import { ChangeLog } from 'src/helpers/Changelog'
import usePagination from 'src/hooks/usePagination'
import theme from 'src/theme/theme'
import { ChangeLogType } from 'src/types/ChangelogType'

export default function ChangelogPage() {
  const [filters, setFilters] = useState({ limit: 10, offset: 0 })
  const [count = 0, data = []] = ChangeLog.list(filters.limit, filters.offset)
  const pagination = usePagination({ data, count })

  return (
    <Stack component={'section'} maxWidth={'1024px'} mx="auto" width={'100%'} px={2} py={4} gap={3}>
      <Stack component={'header'}>
        <Typography variant="h4" fontWeight={800} color={theme.palette.primary.main}>
          Changelog
        </Typography>
        <Typography>Stay updated with all the latest features, improvements, and fixes to our CMS platform.</Typography>
      </Stack>
      <Stack component={'section'}>
        {!count ? (
          <NoDataAvailable subtitle="No changelogs have been published yet. Please check back later." />
        ) : (
          <Stack gap={2} component={'section'}>
            <Stack component={'section'} direction={'row'} justifyContent={'flex-end'} alignItems={'center'}>
              <Typography>Showing {count < filters.limit ? count : `${filters.limit} of ${count}`} items</Typography>
            </Stack>
            <Stack gap={2} component={'section'}>
              {data.map((d) => {
                return <Item key={d._id} {...(d as ChangeLogType)} />
              })}
            </Stack>
            <Stack component={'section'} direction={'row'} justifyContent={'flex-end'} alignItems={'center'}>
              <PaginationControl {...pagination} last={pagination.lastPage} />
            </Stack>
          </Stack>
        )}
      </Stack>
    </Stack>
  )
}
